import * as React from "react";
import {Icon, Label, Table} from "semantic-ui-react";
import {Tab} from "semantic-ui-react";
import Button from "src/components/Button";
import Dialog from "src/components/Dialogs/Dialog";

interface IPCCDSyncDialogProps {
    result: any;
    t: reactI18Next.TranslationFunction;
    onClose: () => void;
    incompletePCCD?: string;
    inCompleteDTL:string;
    completeDTL:string;
    noDataDTL:string;
    col1:string;
    col2:string;
    tabTitle:string;
}

export const PCCDSyncDialog = (props: IPCCDSyncDialogProps) => {
    return (
        <Dialog
            title={"PCCD-Sync"}
            open={true}
            scrolling={true}
            actions={[
                <Button
                    key={"closeButton"}
                    icon={"ban"}
                    onClick={props.onClose}
                />
            ]}
        >
            <Tab
                panes={[
                    {
                        menuItem: props.tabTitle,
                        render: () => (
                            Object.keys(props.result.missingPCCDSyncItems).length === 0 && !props.result.pccdNoData ?
                                <Label color='green' className='width--100Percent font-size--medium'>
                                    <Icon name='check circle' />
                                    <Label.Detail style={{verticalAlign: 'baseline', marginLeft: '-5px'}}>{props.completeDTL}</Label.Detail>
                                </Label>
                                : Object.keys(props.result.missingPCCDSyncItems).length === 0 && props.result.pccdNoData ?
                                    <Label color='red' className='width--100Percent font-size--medium'>
                                        <Icon name='warning sign' />
                                        <Label.Detail style={{verticalAlign: 'baseline',marginLeft: '-5px'}}>{props.noDataDTL}</Label.Detail>
                                    </Label>
                                    : <>
                                        <Label color='yellow' className='width--100Percent font-size--medium'>
                                            <Icon name='warning circle' />
                                            {props.incompletePCCD && props.incompletePCCD}
                                            <Label.Detail style={{verticalAlign: 'baseline'}}>{props.inCompleteDTL}</Label.Detail>
                                        </Label>
                                        <Table
                                            celled={true}
                                            structured={true}
                                        >
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>{props.col1}</Table.HeaderCell>
                                                    <Table.HeaderCell>{props.col2}</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {Object.keys(props.result.missingPCCDSyncItems).map((key: string, index: number) => {
                                                    return (
                                                        <Table.Row key={'row-' + index}>
                                                            <Table.Cell>
                                                                <Label ribbon={true}>{key}</Label>
                                                            </Table.Cell>
                                                            <Table.Cell>{props.result.missingPCCDSyncItems[key].join(', ')}</Table.Cell>
                                                        </Table.Row>
                                                    );
                                                }
                                                )}
                                            </Table.Body>
                                        </Table>
                                    </>
                        )
                    }
                ]}
            />
        </Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/views/common/PCCDSyncDialog.tsx